module.exports = __webpack_public_path__ + "static/media/Calibre-LightItalic.f34c1430.woff2";